module.exports = __webpack_public_path__ + "static/media/position.3a9b44f4.svg";